import type { Order } from "../Order.js";

export function isOnlineOrder(order: Partial<Pick<Order, "products" | "vouchers">>): boolean {
	return (order.products ?? []).length === 0 && (order.vouchers ?? []).length > 0;
}
